import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../core/services/authentication.service";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authService: AuthenticationService
    ) { }

    ngOnInit() {
        this.route.queryParams
            .subscribe((params) => {
                const code = params['code'];
                const idNo = params['idNo'];
                const urlObject = new URL(window.location.href);
                const redirectUri = urlObject.origin + urlObject.pathname;
                let scopeType:any;
                let clientId = params['client_id'];

                // if(clientId == null || clientId == undefined){
                //     clientId = "vcontract"
                // }

                if(clientId == 'vcontract'){
                    scopeType = 1;
                }else if(clientId == 'scontract'){
                    scopeType = 2;
                }else{
                    scopeType = null;
                }

                let payload = { code, redirectUri, idNo, scopeType, clientId};
                if(!scopeType){
                    delete payload.scopeType;
                    delete payload.clientId;
                }

                this.authService.loginWithCode(payload).subscribe(rs => {
                    if (rs) {
                        window.location.href = 'home-enterprise';
                    //    this.redirectAfterLogin('home-enterprise',null)
                    }
                });
            }
            );
    }

    redirectAfterLogin(type, option: any) {
        if (option) {
            this.router.navigate([type], option)
        }
        else {
            this.router.navigate([type])
        }
    }

}
